/* Review photo lightbox.
   Customer photos that can't be opened read as stock art. Tap any review
   photo (or the "+N more" tile) to open it full screen: swipe or arrows to
   move, Esc / tap outside / × to close. Delegated, so it works on photos
   the reviews widget renders late or re-renders. */
(function(){
var SCOPE='#reviews, #if-reviews, [id*="review"], [class*="review"]';
var list=[], at=0, ov, img, count, prev, next;

var css=document.createElement('style');
css.textContent='#reviews img, #if-reviews img, [id*="review"] img, [class*="review"] img{cursor:zoom-in;}';
document.head.appendChild(css);

function big(src){
return src.replace(/([?&])width=\d+/,'$1width=1400').replace(/_(\d+)x(\d*)\.(webp|jpg|jpeg|png)/i,'.$3');
}

function btn(html,style,label){
var b=document.createElement('button');
b.type='button';b.setAttribute('aria-label',label);
b.setAttribute('style','position:absolute; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; padding:0; color:#fff; background:rgba(255,255,255,0.14); border-radius:50%; '+style);
b.innerHTML=html;
return b;
}

function build(){
ov=document.createElement('div');
ov.setAttribute('style','position:fixed; inset:0; z-index:2147483000; background:rgba(10,12,16,0.94); display:none; align-items:center; justify-content:center; touch-action:pan-y;');
img=document.createElement('img');
img.alt='Customer photo';
img.setAttribute('style','max-width:94vw; max-height:84vh; object-fit:contain; border-radius:12px; box-shadow:0 20px 60px rgba(0,0,0,0.5); user-select:none; -webkit-user-drag:none;');
count=document.createElement('div');
count.setAttribute('style','position:absolute; top:18px; left:50%; transform:translateX(-50%); color:#fff; font:700 13px Barlow,sans-serif; letter-spacing:.6px; background:rgba(255,255,255,0.14); padding:6px 12px; border-radius:999px;');
var close=btn('<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"></path></svg>','top:12px; right:12px; width:44px; height:44px;','Close');
prev=btn('<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5 8 12l7 7"></path></svg>','left:12px; top:50%; transform:translateY(-50%); width:46px; height:46px;','Previous photo');
next=btn('<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"></path></svg>','right:12px; top:50%; transform:translateY(-50%); width:46px; height:46px;','Next photo');
ov.appendChild(img);ov.appendChild(count);ov.appendChild(close);ov.appendChild(prev);ov.appendChild(next);
document.body.appendChild(ov);
close.onclick=hide;
prev.onclick=function(e){e.stopPropagation();go(-1);};
next.onclick=function(e){e.stopPropagation();go(1);};
ov.onclick=function(e){if(e.target===ov)hide();};
var sx=null;
ov.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
ov.addEventListener('touchend',function(e){
if(sx===null)return;
var dx=e.changedTouches[0].clientX-sx; sx=null;
if(Math.abs(dx)>45)go(dx<0?1:-1);
});
document.addEventListener('keydown',function(e){
if(!ov||ov.style.display!=='flex')return;
if(e.key==='Escape')hide();
if(e.key==='ArrowRight')go(1);
if(e.key==='ArrowLeft')go(-1);
});
}

function paint(){
img.src=big(list[at]);
count.textContent=(at+1)+' / '+list.length;
var many=list.length>1;
prev.style.display=many?'flex':'none';
next.style.display=many?'flex':'none';
}
function go(d){if(!list.length)return;at=(at+d+list.length)%list.length;paint();}
function show(srcs,i){if(!ov)build();list=srcs;at=i;paint();ov.style.display='flex';document.documentElement.style.overflow='hidden';}
function hide(){if(!ov)return;ov.style.display='none';document.documentElement.style.overflow='';}

function photosIn(root){
var out=[];
var ims=root.querySelectorAll('img');
for(var i=0;i<ims.length;i++){
var r=ims[i].getBoundingClientRect();
if(r.width<44||r.height<44)continue;
var s=ims[i].currentSrc||ims[i].src;
if(s&&out.indexOf(s)<0)out.push(s);
}
(window.IF_REVIEW_PHOTOS||[]).forEach(function(s){if(out.indexOf(s)<0)out.push(s);});
return out;
}

document.addEventListener('click',function(e){
var t=e.target;
if(!t||!t.closest)return;
var root=t.closest(SCOPE);
if(!root)return;
var isImg=t.tagName==='IMG';
var box=t.closest('div,button,span')||t;
var tile=!isImg&&/^\s*\+\s*\d+/.test(box.textContent||'')&&box.textContent.length<30;
if(!isImg&&!tile)return;
if(isImg){var r=t.getBoundingClientRect();if(r.width<44||r.height<44)return;}
var srcs=photosIn(root);
if(!srcs.length)return;
e.preventDefault();e.stopPropagation();
var i=isImg?Math.max(0,srcs.indexOf(t.currentSrc||t.src)):Math.min(srcs.length-1,8);
show(srcs,i);
},true);
})();
